module.exports = __webpack_public_path__ + "/login_ui/img/me-957be31be485fa765e2b15fda5b7acfd.svg";